import React, { useState, useEffect } from 'react';
import AddItem from './AddItem';
import ShowList from './ShowList';

const ReactList = (props)=>{

    const [items, setItems] = useState([])
    const [readStagedData, setReadStagedData] = useState(false)

    const stagedData = ()=>{
        if (typeof props.reactList != "undefined" && readStagedData === false) {
            setItems(props.reactList)
            setReadStagedData(true)
         }
    }

    const setReactList = ()=>{
        props.setReactList(items);
    }

    useEffect(()=>{
        stagedData();
        setReactList();
    })

    return(
        <div className = "react-list-items-container">
            <ShowList items={items} setItems={setItems}/>
            <AddItem items={items} setItems={setItems}/>
        </div>
    )

}

export default ReactList